import React, { ButtonHTMLAttributes } from 'react';

type Variant = 'solid' | 'ghost' | 'soft' | 'danger' | 'outline' | 'default';

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg px-3.5 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 disabled:opacity-50 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  solid: 'bg-indigo-600 text-white hover:bg-indigo-500',
  ghost: 'bg-white/0 text-slate-100 hover:bg-white/10',
  soft: 'bg-indigo-500/15 text-indigo-200 hover:bg-indigo-500/25',
  danger: 'bg-rose-600 text-white hover:bg-rose-500',
  outline: 'border border-slate-300 text-slate-700 hover:bg-slate-50',
  default: 'bg-slate-600 text-white hover:bg-slate-500',
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant };

export default function Button({ variant = 'solid', className = '', ...props }: Props) {
  return <button className={`${base} ${variants[variant]} ${className}`} {...props} />;
}
